import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import { WEALTH_CARD_VARIANTS } from "@pages/Section/layouts/Wealth/utils/constant";
import Card from "@particles/card/Card";
import { cn } from "@util/helpers";

type WealthThirdRowProps = {
  /** Optional className for the component */
  className?: string;
  /** The card props for the wealth third row component */
  cardProps: ComponentProps<typeof Card>[];
};

/**
 * The wealth third row component for the wealth page.
 * NO FIGMA LINK
 * */
const WealthThirdRow = ({
  className,
  cardProps,
}: WealthThirdRowProps): React.ReactElement => {
  const columns = ["INVEST", "TRUSTED ADVISOR", "ASSET MANAGER"];

  return (
    <div
      data-testid="wealth-third-row-component"
      className={cn(
        "grid gap-6 border-t border-black pt-3 lg:grid-cols-3",
        className
      )}
    >
      <>
        {cardProps.map((cardProps, index) => {
          return (
            <div className="pb-12 lg:pb-0" key={columns[index]}>
              <BlockTitle text={columns[index]} rootClassName="mb-3" />

              <Card
                {...cardProps}
                variations={WEALTH_CARD_VARIANTS.thirdRow}
                className="items-stretch"
              />
            </div>
          );
        })}
      </>
    </div>
  );
};

export default WealthThirdRow;
